export const BEACH_READY_SCORE = {
  // Default coins
  "0x50b7545627a5162f82a992c33b87adc75187b218": 3, //BTC
  "0x49d5c2bdffac6ce2bfdb6640f4f80f226bc10bab": 4, //ETH
  "0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7": 10, //AVAX
  "0x5947bb275c521040051d82396192181b413227a3": 6, //LINK
  "0xA32608e873F9DdEF944B24798db69d80Bbb4d1ed": 5, //CRA
  "0x6e84a6216ea6dacc71ee8e6b0a5b7322eebc0fdd": 4, //JOE
  "0x22d4002028f537599bE9f666d1c4Fa138522f9c8": 2, //PTP

  // Stablecoins
  "0xa7d7079b0fead91f3e65f86e8915cb59c1a4c664": 10, //USDC
  "0xd586E7F844cEa2F87f50152665BCbc2C279D8d70": 10, //DAI
  "0xc7198437980c041c805A1EDcbA50c1Ce5db95118": 10, //USDT

  // Farm tokens
  "0xa389f9430876455c36478deea9769b7ca4e3ddb1": 9, //USDC.e-AVAX
  "0x781655d802670bba3c89aebaaea59d3182fd755d": 9, //MIM-AVAX
  "0xed8cbd9f0ce3c6986b22002f03c6475ceb7a6256": 9, //AVAX-USDT.e
  "0xfe15c2695f1f920da45c30aae47d11de51007af9": 7, //WETH.e-AVAX
  "0x57319d41f71e81f3c65f2a47ca4e001ebafd4f33": 6, //XJOE
  "0x454e67025631c065d3cfad6d71e6892f74487a15": 5, //JOE-AVAX
  "0x6f3a0c89f611ef5dc9d96650324ac633d02265d3": 5, //LINK.e-AVAX
  "0xcdfd91eea657cc2701117fe9711c9a4f61feed23": 1, //PTP-AVAX
};

export default {
  BEACH_READY_SCORE,
};
